import React from 'react';
import '../assets/styles/About.scss';

const About: React.FC = () => {
  return (
    <section className="aboutme-section" id="about">
      <h2 className="aboutme-quote">
        “One must not divert attention from the goal because of the difficulty of the path.”
      </h2>
      <p className="aboutme-description">
        I'm Luis, an 19-year-old aspiring technologist from Guatemala currently finishing my Computer Science diploma.
        I'm passionate about software development, artificial intelligence, and cybersecurity. I believe in the power
        of education, discipline, and innovation to create real change. My goal is to study abroad, grow as a global professional, 
        and build solutions that impact lives — starting with mine and those around me.
      </p>
    </section>
  );
};

export default About;

